<template>
  <div class="container">
    <div class="row help-wrapper">
      <!-- <header-about /> -->
      <div id="corpo" class="col s12">
        <h5 class="center" id="manual">Como funciona</h5>
        <p>
          Pensando neste momento de distanciamento social, a Recad Censo® foi criada para que você possa ficar quite com
          o Censo Previdenciário,
          atualizando as suas próprias informações e digitalizando os seus documentos pessoais, de forma muito rápida,
          prática, segura e o principal: sem
          precisar sair do conforto do seu lar. Legal né? Continue lendo para saber mais sobre esta ferramenta incrível
          ou <router-link to="/Tutorial/">clique aqui para
            assistir aos vídeo-tutoriais</router-link>.
        </p>
        <h5 id="antes-de-comecar">Antes de começar</h5>
        <p>
          Tenha em mãos todos os seus documentos pessoais, caso você seja um pensionista, reúna também os documentos
          pessoais do instituidor da sua pensão.
          A lista completa você pode conferir <router-link to="/Info/">nesta página</router-link>.
        </p>
        <h5 id="sem-retrabalho">Sem retrabalho</h5>
        <p>
          Já iniciou e faltou um documento? Não tem problema, você pode
          preencher as outras informações dos documentos que você já tem em mãos e depois retomar exatamente de onde
          parou, sem precisar refazer nada. ;)
        </p>
        <h5 id="informacoes-adicionais">Informações adicionais</h5>
        <p>
          Ao informar os seus dependentes, as certidões de casamento(cônjuge) e nascimento(filho) dos mesmos devem ser
          digitalizadas no campo refente esses documentos na
          seção "<strong>7 - IMAGENS</strong>", conforme a imagem abaixo
        </p>
        <p class="col s12">
          <img data-caption="IMAGEM MERAMENTE ILUSTRATIVA" class="col s12 m3 materialboxed"
            src="@/assets/img/certidoes_de_nascimento_casamento.png" alt="certidoes_de_nascimento_casamento" />
        </p>
        <p>
          Se você é um pensionista, você deve utilizar o seus dados pessoais, CPF e Data de Nascimento ao fazer o login.
        </p>
        <p>
          Campos desativados e com destaque na cor amarela, como no exemplo abaixo, indicam que tal informação só pode
          ser alterada pessoalmente na sede do Instituto de Previdência:
        </p>
        <p class="col s12">
          <img data-caption="IMAGEM MERAMENTE ILUSTRATIVA" class="col s12 m3 materialboxed"
            src="@/assets/img/nao_editavel.png" alt="nao_editavel" /><!-- MUDAR ESSA IMAGEM -->
        </p>
        <p>
          Este ícone <i class="material-icons red-text">error</i>, na cor vermelha indica que um documento obrigatório
          ou uma seção inteira não estão preenchidos corretamente e você deve revisá-los.
        </p>
        <p>
          Este ícone <i style="color: #00A0B2;" class="material-icons">check</i>, na cor azul indica que um documento ou
          uma seção inteira estão preenchidos corretamente. Como os seus dados atuais no
          Instituto de Previdência estarão disponíveis para visualiação e/ou atualização nesta aplicação, é recomendo
          que você confira se os dados estão corretos e atuais, mesmo que
          ícone de sucesso já esteja presente ao iniciar.
        </p>
        <h5>Validação dos dados</h5>
        <p>
          Após o preenchimento completo de todas as informações e documentos digitalizados, o seu cadastro é enviado
          para processamento pela nossa equipe
          técnica que irá verificar se está tudo em ordem com o seu cadastro, corrigindo eventuais erros de digitação e
          transcrevendo os dados de todos os documentos
          digitalizados. Quando o seu cadastro estiver nesta fase, ao acessá-lo você verá a seguinte mensagem:
        </p>
        <p class="col s12">
          <img data-caption="IMAGEM MERAMENTE ILUSTRATIVA" class="col s12 m3 materialboxed"
            src="@/assets/img/cadastro_em_analise.png" alt="cadastro_em_analise" />
        </p>
        <p>
          Nesta fase o seu cadastro ficará temporariamente bloqueado para novas atualizações até que ele seja verificado
          por um de nossos técnicos. Enquanto isso
          você deve apenas aguardar, mas este processo não é feito em tempo-real e pode levar alguns dias, mas fique
          tranquilo, se você informou um telefone celular
          você receberá nele um SMS nosso assim que tivermos novidades acerca da conclusão ou necessidade de correção do
          seu cadastro, caso contrário, nós recomendamos
          que você verifique o seu cadastro aqui na Recad Censo® em média uma vez a cada 2 ou 3 dias.
        </p>
        <h5>Correção e reenvio</h5>
        <p>
          Em regra as informações estão sempre consistentes e o cadastro finalizado, porém imprevistos acontecem não é
          mesmo?
          Nesse caso, o técnico responsável pela validação do seu cadastro irá registrar o que houve de errado para que
          você corrija e submeta o cadastro para processamento novamente.
          Quando o seu cadastro estiver nesta fase, ao acessá-lo você verá a seguinte mensagem:
        </p>
        <p class="col s12">
          <img data-caption="IMAGEM MERAMENTE ILUSTRATIVA" class="col s12 m3 materialboxed"
            src="@/assets/img/cadastro_recusado.png" alt="cadastro_recusado" />
        </p>
        <p>
          Nesta fase o seu cadastro é liberado novamente para que você possa corrigir as inconsistências apontadas pela
          nossa equipe. Fique vontade para também
          adicionar outros documentos ou informações que você eventualmente não adicionou no primeiro envio. Após o novo
          envio, você voltará para o passo anterior:
          o processamento.
        </p>
        <h5>Fim e comprovante</h5>
        <p>
          Assim que todos os seus dados e documentos forem validados pela nossa equipe técnica e estiverem de acordo com
          o decreto que regulamenta este processo de recenseamento o seu procedimento de
          recadastramento estará concluído e você poder fazer o download do comprovante para impressão e arquivamento.
          Quando o seu cadastro estiver nesta fase, ao acessá-lo você verá a seguinte mensagem:
        </p>
        <p class="col s12">
          <img data-caption="IMAGEM MERAMENTE ILUSTRATIVA" class="col s12 m3 materialboxed"
            src="@/assets/img/cadastro_finalizado.png" alt="cadastro_finalizado" />
        </p>
        <p>
          Para imprimir o comprovante basta clicar no botão azul e pronto. Prabéns, você cumpriu o seu dever de servidor
          público, sem precisar sair de casa. \o/
        </p>
        <h5>Contato</h5>
        <p>
          Se você ainda tem alguma dúvida e deseja falar com um de nossos antendentes, as opções de contatos estão
          disponíveis <router-link to="/Contato/">nesta página</router-link>.
        </p>
        <div class="col s12 center">
          <router-link to="/Censo/" class="waves-effect waves-light btn btn-theme fAboutLogin col s8 m3"
            id="abouBtnLogin">Iniciar</router-link>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import HeaderAbout from "@/components/HeaderAbout.vue"

export default {
  name: 'Ajuda',
  components: {
    "header-about": HeaderAbout
  },
  data() {
    return {
      active_step: 1
    }
  },
  methods: {
    initMaterialize() {
      setTimeout(() => {
        M.Collapsible.init((document.querySelectorAll('.collapsible')))
        M.Materialbox.init(document.querySelectorAll('.materialboxed'))
      }, 100)
    }
  },
  mounted() {
    localStorage.setItem('reviewd', false)
    this.$root.$emit('stopLoadingHeader')
    this.initMaterialize()

  }
}
</script>


// WEBPACK FOOTER //
// src/components/Ajuda.vue